import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'shared-logout',
  templateUrl: './shared-logout.component.html',
  styleUrls: ['./shared-logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedLogoutComponent implements OnInit {
  counter: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { counter: number },
    private _logoutDialogRef: MatDialogRef<SharedLogoutComponent>,
    private _dialogRef: MatDialog,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.counter = this.data.counter;
  }

  confirmDialog() {
    this._logoutDialogRef.close();
    this._dialogRef.closeAll();
    this.cd.detectChanges();
  }

  updateCounter(newCounter: number): void {
    this.counter = newCounter;
    this.cd.detectChanges();
  }

  closeDialog() {
    this._logoutDialogRef.close(true);
    this.cd.detectChanges();
  }
}
